import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: '#00D7FF',
    },

    st1: {
        fill: '#FFFFFF',
    },

    st2: {
    },

    st3: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st4: {
        clipPath: 'url(#SVGID_2_)',
    },

    // st12: {
    //     fill: '#00D7FF',
    // },
}));
